import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const LegalNotice = () => {
  return (
    <div className='legal-notice' id='legalNotice'>
      <Container>
        <Row>
          <Col xs={12}>
            <h1 className='h1'>Impressum</h1>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h2 className='h3'>Betreiber:</h2>
            <address className='p'>
              Notarin Yvonne Luz <br />
              Kreuznacher Str. 68 <br />
              70372 Stuttgart
            </address>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h2 className='h3'>Kontakt:</h2>
            <p className='p telephone'>
              <span className='desc'>Telefon:</span> (0711) 955926-0
            </p>
            <p className='p fax'>
              <span className='desc'>Telefax:</span> (0711) 955926-99
            </p>
            <p className='p email'>
              <span className='desc'>E-Mail:</span> info@ll-notare.de
            </p>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h2 className='h3'>Vertreten durch:</h2>
            <p className='p'>Notarin Yvonne Luz</p>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h2 className='h3'>Umsatzsteuer-ID:</h2>
            <p className='p'>
              <span className='desc'>Umsatzsteuer-Identifikationsnummer nach §27a Umsatzsteuergesetz:</span> DE256638513
            </p>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h2 className='h3'>Berufsbezeichnung:</h2>
            <p className='p'>Notarin</p>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h2 className='h3'>Verliehen in/durch:</h2>
            <p className='p'>
              Das Amt des Notars und damit die gesetzliche Berufsbezeichnung „Notarin“ ist Frau Notarin Yvonne Luz in
              der Bundesrepublik Deutschland vom Justizministerium Baden-Württemberg verliehen worden.
            </p>
            <address className='p'>
              <span className='desc'>Justizministerium Baden-Württemberg</span> <br />
              Schillerplatz 4 <br />
              70173 Stuttgart <br />
              Deutschland
            </address>
            <p className='p telephone'>
              <span className='desc'>Telefon:</span> 0711-279-0
            </p>
            <p className='p fax'>
              <span className='desc'>Telefax:</span> 0711-279-2264
            </p>
            <p className='p email'>
              <span className='desc'>E-Mail:</span> poststelle@jum.bwl.de
            </p>
            <p className='p web'>
              <span className='desc'>Website:</span> www.jum.baden-wuerttemberg.de
            </p>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h2 className='h3'>Zuständige Kammer:</h2>
            <p className='p'>Notarkammer Baden-Württemberg</p>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h2 className='h3'>Zuständige Aufsichtsbehörden:</h2>
          </Col>
          <Col xs={12} lg={6}>
            <address className='p'>
              <span className='desc'>Präsident des Landgerichts Stuttgart</span> <br />
              Urbanstraße 20 <br />
              70182 Stuttgart
            </address>
            <p className='p telephone'>
              <span className='desc'>Telefon:</span> 0711-212-0
            </p>
            <p className='p fax'>
              <span className='desc'>Telefax:</span> 0711-212-3556 oder 3535
            </p>
            <p className='p email'>
              <span className='desc'>E-Mail:</span> poststelle@lg.stuttgart.justiz.bwl.de
            </p>
            <p className='p web'>
              <span className='desc'>Website:</span> www.landgericht-stuttgart.de
            </p>
          </Col>
          <Col xs={12} lg={6}>
            <address className='p notarkammer'>
              <span className='desc'>Notarkammer Baden-Württemberg</span> <br />
              Königstraße 21 <br />
              70173 Stuttgart
            </address>
            <p className='p telephone'>
              <span className='desc'>Telefon:</span> 0711-291 934
            </p>
            <p className='p fax'>
              <span className='desc'>Telefax:</span> 0711-2200 9310
            </p>
            <p className='p email'>
              <span className='desc'>E-Mail:</span> notarkammer.baden-wuerttemberg@notarnet.de
            </p>
            <p className='p web'>
              <span className='desc'>Website:</span> www.notarkammer-baden-wuerttemberg.de
            </p>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h2 className='h3'>Folgende berufsrechtliche Regelungen finden Anwendung:</h2>
            <p className='p'>
              Bundesnotarordnung, Beurkundungsgesetz, Dienstordnung für Notarinnen und Notare, Richtlinien der
              Notarkammer Baden-Württemberg, Gerichts- und Notarkostengesetz Soweit es sich bei den vorgenannten
              Vorschriften um formelle Gesetze handelt, sind diese in den einschlägigen Sammlungen veröffentlicht. Die
              maßgeblichen berufsrechtlichen Regelungen können auf den Internet-Seiten des Bundesjustizministeriums
              (www.gesetze-im-internet.de/volltextsuche.html) sowie der Bundesnotarkammer (www.bundesnotarkammer.de)
              eingesehen werden.
            </p>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h2 className='h3'>Berufshaftpflichtversicherung:</h2>
            <address className='p'>
              <span className='desc'>R+V Allgemeine Versicherung AG</span> <br />
              Raiffeisenplatz 1 <br />
              65189 Wiesbaden <br />
              <span className='desc'>Geltungsbereich:</span> <br />
              Deutschland
            </address>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h2 className='h3'>Verantwortlich für den Inhalt (gem. § 55 Abs. 2 RStV):</h2>
            <address className='p'>
              <span className='desc'>Notarin Yvonne Luz</span> <br />
              Kreuznacher Str. 68 <br />
              70372 Stuttgart
            </address>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h2 className='h3'>Bildrechte:</h2>
            <p className='p'>
              Bei den veröffentlichen Aufnahmen/Bildern handelt es sich um Privataufnahmen, der Veröffentlichung wurde
              von den jeweiligen Fotografen zugestimmt. Soweit die Aufnahmen auf dieser Seite nicht vom Betreiber
              erstellt wurden, stammen diese aus Quellen, die kommerziell frei genutzt werden dürfen.
            </p>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h2 className='h2'>Disclaimer – rechtliche Hinweise</h2>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h3 className='h3'>§ 1 Haftung für Inhalte</h3>
            <p className='p'>
              Die kostenlosen und frei zugänglichen Inhalte dieser Webseite wurden mit größtmöglicher Sorgfalt erstellt.
              Der Anbieter dieser Webseite übernimmt jedoch keine Gewähr für die Richtigkeit und Aktualität der
              bereitgestellten kostenlosen und frei zugänglichen journalistischen Ratgeber und Nachrichten. Namentlich
              gekennzeichnete Beiträge geben die Meinung des jeweiligen Autors und nicht immer die Meinung des Anbieters
              wieder. Allein durch den Aufruf der kostenlosen und frei zugänglichen Inhalte kommt keinerlei
              Vertragsverhältnis zwischen dem Nutzer und dem Anbieter zustande, insoweit fehlt es am
              Rechtsbindungswillen des Anbieters.
            </p>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h3 className='h3'>§ 2 Externe Links</h3>
            <p className='p'>
              Diese Website enthält Verknüpfungen zu Websites Dritter ("externe Links"). Diese Websites unterliegen der
              Haftung der jeweiligen Betreiber. Der Anbieter hat bei der erstmaligen Verknüpfung der externen Links die
              fremden Inhalte daraufhin überprüft, ob etwaige Rechtsverstöße bestehen. Zu dem Zeitpunkt waren keine
              Rechtsverstöße ersichtlich. Der Anbieter hat keinerlei Einfluss auf die aktuelle und zukünftige Gestaltung
              und auf die Inhalte der verknüpften Seiten. Das Setzen von externen Links bedeutet nicht, dass sich der
              Anbieter die hinter dem Verweis oder Link liegenden Inhalte zu Eigen macht. Eine ständige Kontrolle der
              externen Links ist für den Anbieter ohne konkrete Hinweise auf Rechtsverstöße nicht zumutbar. Bei Kenntnis
              von Rechtsverstößen werden jedoch derartige externe Links unverzüglich gelöscht.
            </p>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h3 className='h3'>§ 3 Urheber- und Leistungsschutzrechte</h3>
            <p className='p'>
              Die auf dieser Website veröffentlichten Inhalte unterliegen dem deutschen Urheber- und
              Leistungsschutzrecht. Jede vom deutschen Urheber- und Leistungsschutzrecht nicht zugelassene Verwertung
              bedarf der vorherigen schriftlichen Zustimmung des Anbieters oder jeweiligen Rechteinhabers. Dies gilt
              insbesondere für Vervielfältigung, Bearbeitung, Übersetzung, Einspeicherung, Verarbeitung bzw. Wiedergabe
              von Inhalten in Datenbanken oder anderen elektronischen Medien und Systemen. Inhalte und Rechte Dritter
              sind dabei als solche gekennzeichnet. Die unerlaubte Vervielfältigung oder Weitergabe einzelner Inhalte
              oder kompletter Seiten ist nicht gestattet und strafbar. Lediglich die Herstellung von Kopien und
              Downloads für den persönlichen, privaten und nicht kommerziellen Gebrauch ist erlaubt. Die Darstellung
              dieser Website in fremden Frames ist nur mit schriftlicher Erlaubnis zulässig.
            </p>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h3 className='h3'>§ 4 Datenschutz</h3>
            <p className='p'>
              Unsere Website kann in der Regel ohne die Angabe personenbezogener Daten genutzt werden. Soweit durch den
              Besuch unserer Website Informationen über den Zugriff (Datum, Uhrzeit, betrachtete Seite) gespeichert
              werden, gehören diese nicht zu den personenbezogenen Daten, sondern sind anonymisiert. Sie werden
              ausschließlich zu statistischen Zwecken ausgewertet. Eine Weitergabe an Dritte, zu kommerziellen oder
              nichtkommerziellen Zwecken, findet nicht statt.
            </p>
            <p className='p'>
              Der Anbieter weist ausdrücklich darauf hin, dass die Datenübertragung im Internet (z.B. bei der
              Kommunikation per E-Mail) Sicherheitslücken aufweisen und nicht lückenlos vor dem Zugriff durch Dritte
              geschützt werden kann.
            </p>
            <p className='p'>
              Der Nutzung der Kontaktdaten des Impressums durch Dritte zur gewerblichen Werbung wird hiermit
              ausdrücklich widersprochen, es sei denn der Anbieter hatte zuvor seine schriftliche Einwilligung erteilt
              oder es besteht bereits eine Geschäftsbeziehung. Der Anbieter und alle auf dieser Website genannten
              Personen widersprechen hiermit jeder kommerziellen Verwendung und Weitergabe ihrer Daten.
            </p>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h3 className='h3'>§ 5 Besondere Nutzungsbedingungen</h3>
            <p className='p'>
              Soweit besondere Bedingungen für einzelne Nutzungen dieser Website von den vorgenannten Paragraphen
              abweichen, wird an entsprechender Stelle ausdrücklich darauf hingewiesen. In diesem Falle gelten im
              jeweiligen Einzelfall die besonderen Nutzungsbedingungen.
            </p>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h3 className='h3'>Quelle:</h3>
            <p className='p'>Impressum-Generator von Impressum-Recht.de</p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LegalNotice;
